// src/utils/getLatestReleaseUrl.js

/**
 * Fetches the latest release version and constructs the download URL.
 *
 * @returns {Promise<string>} Direct URL to the latest installer (.exe)
 */
export const getLatestReleaseUrl = async () => {
  const apiUrl =
    "https://api.github.com/repos/isol-pos/epinics-pos-release/releases/latest";

  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`GitHub API error: ${response.status}`);
    }

    const data = await response.json();

    // Get the version tag (e.g., "4.0.28")
    const version = data.tag_name;

    if (!version) {
      throw new Error("Could not find latest release tag.");
    }

    // Build the download URL dynamically
    const downloadUrl = `https://github.com/isol-pos/epinics-pos-release/releases/download/${version}/Epinics-POS-Setup-${version}.exe`;

    return downloadUrl;
  } catch (error) {
    console.error("Error fetching latest release:", error);
    throw error;
  }
};
